import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable, of } from 'rxjs';
import { CommonData } from '../interfaces/common-data';
import { API_URLS } from '../authentication/config';
import {catchError, map} from 'rxjs/operators';
import { HttpClient } from '@angular/common/http';
import {DomSanitizer} from "@angular/platform-browser";

@Injectable({
  providedIn: 'root'
})
export class CommonService {

  private fullPageLoaderVisibility = new BehaviorSubject<boolean>(false);

  constructor(private http: HttpClient, private sanitizer: DomSanitizer) { }

  getCommonData(): Observable<CommonData | null> {
    return this.http.get<CommonData>(API_URLS.getCommonData).pipe(
      map(response => response ? this.processCommonData(response) : null),
      catchError(() => of(null)),
    );
  }

  processCommonData(data: CommonData): CommonData {
    if (data && data.news_data) {
      data.news_data.news = data.news_data.news.map(item => ({
        ...item,
        safe_news_content: this.sanitizer.bypassSecurityTrustHtml(item.news_content)
      }));
      data.news_data.ad = data.news_data.ad.map(item => ({
        ...item,
        safe_ad_content: this.sanitizer.bypassSecurityTrustHtml(item.ad_content)
      }));
    }
    return data;
  }

  setFullPageLoaderVisibility(visibility: boolean): void {
    this.fullPageLoaderVisibility.next(visibility);
  }

  getFullPageLoaderVisibility(): Observable<boolean> {
    return this.fullPageLoaderVisibility;
  }

  isClientMobile(): boolean {
    const userAgent = window.navigator.userAgent;

    return userAgent.search('(Android|iPhone|Phone)') > -1
  }

  downloadBlob(content: Blob, fileName: string): void {
    const url = window.URL.createObjectURL(content);
    const a = document.createElement('a');
    document.body.appendChild(a);
    a.setAttribute('style', 'display: none');
    a.href = url;
    a.download = fileName;
    a.click();
    window.URL.revokeObjectURL(url);
    a.remove();
  }

}
